import { render, staticRenderFns } from "./MerchantAccountList.vue?vue&type=template&id=2ca9ba78&scoped=true"
import script from "./MerchantAccountList.vue?vue&type=script&lang=js"
export * from "./MerchantAccountList.vue?vue&type=script&lang=js"
import style0 from "./MerchantAccountList.vue?vue&type=style&index=0&id=2ca9ba78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9ba78",
  null
  
)

export default component.exports